import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { fetchArticles } from "../services/apiService";
import { useCollectionStore } from "../store/collectionStore";
import { useUserStore } from "../store/userStore";
import { queryClient } from "../services/tanStackClient";

export function usePrefetchCollections() {
  const { collectionList } = useCollectionStore();
  const { user } = useUserStore();
  const { i18n } = useTranslation();

  const userId = user?.firebaseUser?.uid;
  const language = i18n.language;

  const collectionIdsKey = useMemo(
    () => collectionList.map((c: any) => c.id).join(","),
    [collectionList]
  );

  useEffect(() => {
    if (!userId || !collectionList?.length) return;

    collectionList.forEach((collection, index) => {
      setTimeout(() => {
        queryClient.prefetchInfiniteQuery({
          queryKey: ["articles", language, collection.id, userId],
          queryFn: ({ pageParam }) => fetchArticles(pageParam),
          initialPageParam: {
            direction: "newer" as const,
            cursor: undefined,
            collectionId: collection.id,
          },
          staleTime: 60 * 60 * 1000,
        });
      }, 20 * index); // stagger prefetching to avoid overwhelming the device

    });
  }, [collectionIdsKey, userId, language]);
}